import React, { useCallback, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getEducationalResourcesData } from "services/_educational_resources";
import Pagination from "components/Pagination";
import rightArrow from "../../assets/images/right_arrow.svg";
import Plusshape from "../../assets/images/Plusshape.png";
import Spondyloarthritis from "./components/Spondyloarthritis";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EducationalPage = ({ isPagination }) => {
  const [educationData, setEducationData] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

    const navigate = useNavigate();
  

  const initialData = useCallback(async () => {
    const response = await getEducationalResourcesData(
      `page=${page}&per_page=${perPage}`
    );
    if (response.isSuccess) {
      setRecords(response.data.records || []);
      setEducationData(response.data.records);
      setTotalRecords(response.data.total_records || 0);

      if (response.data.total_records && perPage) {
        setTotalPages(Math.ceil(response.data.total_records / perPage));
      }
    }
  }, [page, perPage]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const maineducationData = isPagination
    ? educationData
    : educationData.slice(0, 3);

  return (
    <>
      <section className="py-[20px] pb-[30px] educational relative ">
        <img
          src={Plusshape}
          alt=""
          className="absolute left-0 bottom-[-70px] w-[300px] "
        />
        <div className="container">
          <div className="flex justify-center items-center ">
            <h1 className="heading">
              Educational Information for Axial Spondyloarthritis
            </h1>
          </div>

          <div className="educational_grid mt-[50px] mt-[40px] flex flex-wrap justify-center gap-[30px] w-full mx-auto">
            {educationData.length > 0 ? (
              maineducationData.map((val) => {
                const imageUrl = `${BACKEND_URL}${val.image_url}`;
                return (
                  <div className="condion_box  flex flex-col min-h-[343px] overflow-hidden bg-white max-w-[410px] relative w-full rounded-[15px] ">
                    <div className="h-[255px] w-full">
                      <img
                        src={imageUrl}
                        className=" h-full w-full fit-cover "
                        alt=""
                      />
                    </div>

                    <div className="condition_content  flex flex-col justify-between h-full   relative">
                      <div className="pt-[15px] p-[15px]">
                        <h2 className="text-[18px] mb-[7px]  font-[700] text-[#000D44] ">
                          {val.title}
                        </h2>
                        <p className="text-[15px]  line-clamp-2 font-[500] text-[#000D44]">
                          {val.short_description}
                        </p>
                      </div>
                        <div className="flex justify-end">
                          <button
                          onClick={() =>
                              navigate(`/educational-info/view-educational-resource/${val.id}`)
                            }
                            className="font-[400] !rounded-tr-none !rounded-bl-none rounded-[5px] p-[7px] px-[12px] bg-[#1F2B6C] text-white "
                          >
                            <div className="button_box w-[39px] flex justify-center rounded-[3px] items-center h-[30px] bg-white ">
                              <img
                                src={rightArrow}
                                alt=""
                                className="invert-1 w-[22px]"
                              />
                            </div>
                          </button>
                        </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <h1 className="text-center">No Data found</h1>
            )}
          </div>

          {!isPagination && (
            <div className="flex justify-end  mt-[50px]">
              <NavLink
                className="font-[400] flex items-center gap-[10px] rounded-[5px] p-[7px] px-[12px] bg-[#1F2B6C] text-white "
                to="/educational-info"
              >
                View More
                <div className="button_box w-[39px] flex justify-center rounded-[3px] items-center h-[30px] bg-white ">
                  <img src={rightArrow} alt="" className="invert-1 w-[22px] " />
                </div>
              </NavLink>
            </div>
          )}

          {isPagination && (
            <div className="md:py-[20px] py-[10px]">
              <Pagination
                page={page}
                perPage={perPage}
                totalRecords={totalRecords}
                totalPages={totalPages}
                records={records}
                prevButton={prevButton}
                nextButton={nextButton}
              />
            </div>
          )}
        </div>
      </section>

      {isPagination && <Spondyloarthritis />}
    </>
  );
};

export default EducationalPage;
